export enum PrototypeAnswer {
  YES = 'yes',
  NO = 'no',
}
